import { QueryClient } from 'react-query';

// Create a client with default settings for caching
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // Don't refetch when window is focused
      refetchOnMount: false, // Don't refetch when component mounts
      cacheTime: 1000 * 60 * 10, // Cache data for 10 minutes 
      staleTime: 1000 * 60 * 5, // Consider data stale after 5 minutes
      retry: 1, // Only retry failed requests once
    },
  },
});

// Key factories for consistent cache keys
export const queryKeys = {
  products: {
    all: 'products',
    lists: () => [queryKeys.products.all, 'list'],
    list: (filters) => [...queryKeys.products.lists(), filters],
    details: () => [queryKeys.products.all, 'detail'],
    detail: (id) => [...queryKeys.products.details(), id],
  },
  leagues: {
    all: 'leagues'
  },
  auth: {
    profile: 'profile',
    admin: 'admin'
  },
  orders: {
    all: 'orders',
    detail: (id) => [queryKeys.orders.all, id]
  }
}; 